import React, { Component } from 'react';
import { Button, Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';

import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';
import { dateSortMethod } from 'Common/GridHelper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';

class ExceptionTable extends Component {
  deleteException = (exception, rowIndexWithPaging, i) => {
    this.props.onDelete(i);
  };

  editException = (exception, rowIndexWithPaging, i) => {
    this.props.onEdit(exception, i);
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.editException,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: this.deleteException,
    },
  ];

  columns = [
    {
      Header: 'Description',
      accessor: Fields.Description,
      filterable: true,
      sortable: true,
    },
    {
      Header: 'Begin Day',
      accessor: Fields.BeginDay,
      filterable: false,
      width: 150,
      style: { textAlign: 'center' },
      sortable: true,
      sortMethod: dateSortMethod,
    },
    {
      Header: 'End Day',
      accessor: Fields.EndDay,
      filterable: false,
      width: 150,
      style: { textAlign: 'center' },
      sortable: true,
      sortMethod: dateSortMethod,
    },
    {
      Header: 'Serving?',
      accessor: Fields.IsServing,
      filterable: false,
      style: { textAlign: 'center' },
      width: 100,
      Cell: ({ original }) => {
        return <Checkbox checked={original[Fields.IsServing]} disabled />;
      },
    },
    {
      Header: (props) => {
        const { isReadOnly, firstDay, lastDay } = this.props;
        const disabled =
          isReadOnly ||
          !firstDay ||
          firstDay.length === 0 ||
          !lastDay ||
          lastDay.length === 0;

        return (
          <Button
            content="Add"
            disabled={disabled}
            size={'tiny'}
            onClick={this.props.onAddClick}
          />
        );
      },
      style: { textAlign: 'center' },
      Cell: (gridProps) => {
        if (this.props.isReadOnly) {
          return null;
        }

        return GridContextMenu({ gridProps, options: this.menuOptions });
      },
      width: 100,
      sortable: false,
    },
  ];

  render() {
    const { exceptions, loading } = this.props;

    return (
      <ReactTable
        className={'grid--fixed-row-height'}
        columns={this.columns}
        data={exceptions}
        loading={loading}
        minRows={5}
        pageSize={5}
        showPageJump={false}
        showPageSizeOptions={false}
      />
    );
  }
}

export { ExceptionTable };



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/components/ExceptionTable.js